export default {
  move_down: 'Move Down',
  move_branch: 'Move Branch',
  move_up: 'Move Up'
}
